import { Action } from 'redux';

import { OpenCancelBackgroundJobDialog } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IBackgroundJobInfo } from '../types/BackgroundJobs';

export interface OpenCancelBackgroundJobDialogAction extends Action {
    backgroundJob: IBackgroundJobInfo;
}

export function openCancelBackgroundJobDialogAction(backgroundJob: IBackgroundJobInfo): OpenCancelBackgroundJobDialogAction {
    return {
      type: OpenCancelBackgroundJobDialog,
      backgroundJob,
    };
  }

export const isOpenCancelBackgroundJobDialogAction = isActionFactory<OpenCancelBackgroundJobDialogAction>(OpenCancelBackgroundJobDialog);
